/* BFCM free gift: adds the $0 tin pin when the cart reaches $350, removes it below.
   Runs only inside the gift window (set by theme.liquid) or with ?gift=preview. */
(function () {
  var cfg = window.BFCM_GIFT;
  if (!cfg || window.__bfcmGift) return;
  window.__bfcmGift = true;

  var preview = false;
  try {
    if (/[?&]gift=preview/.test(location.search)) sessionStorage.setItem('bfcmGiftPreview', '1');
    if (/[?&]gift=off/.test(location.search)) sessionStorage.removeItem('bfcmGiftPreview');
    preview = sessionStorage.getItem('bfcmGiftPreview') === '1';
  } catch (e) {}
  var active = cfg.active || preview;

  var busy = false;
  var timer = null;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshView() {
    try {
      var el = document.getElementById('cart-config');
      if (!el || !window.Shopify || !Shopify.theme || !Shopify.theme.cart) return;
      var config = JSON.parse(el.innerHTML || '{}');
      Shopify.theme.cart.getCart().then(function (cart) {
        Shopify.theme.ajaxCart.updateView(config, cart);
      });
    } catch (e) {}
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        var extra = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id !== cfg.variantId) continue;
          if (line) extra = cart.items[i]; else line = cart.items[i];
        }
        if (extra) {
          return post('/cart/change.js', { id: extra.key, quantity: 0 }).then(refreshView);
        }
        var eligible = active && cart.total_price >= cfg.threshold;
        if (eligible && !line) {
          return post('/cart/add.js', { id: cfg.variantId, quantity: 1, properties: { _bfcm_gift: '1' } }).then(refreshView);
        }
        if (line && (!eligible || line.quantity !== 1)) {
          return post('/cart/change.js', { id: line.key, quantity: eligible ? 1 : 0 }).then(refreshView);
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!busy && CART_URL.test(url)) p.then(queue, function () {});
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(String(url))) {
      this.addEventListener('loadend', function () { if (!busy) queue(); });
    }
    return origOpen.apply(this, arguments);
  };

  /* The theme's own cart actions (add to cart, +/-, remove) do not go through
     the wrappers above, but every one of them ends in ajaxCart.updateView. */
  function hookView() {
    var ac = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
    if (!ac || typeof ac.updateView !== 'function') return false;
    if (ac.__bfcmGift) return true;
    var orig = ac.updateView;
    ac.updateView = function () {
      var r = orig.apply(this, arguments);
      if (!busy) queue();
      return r;
    };
    ac.__bfcmGift = true;
    return true;
  }
  if (!hookView()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (hookView() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  /* Gift line: no quantity or remove controls */
  var css = document.createElement('style');
  css.textContent =
    '.item_' + cfg.variantId + ' .js-item-quantity,' +
    '.item_' + cfg.variantId + ' [data-role="product-remove"],' +
    '.item_' + cfg.variantId + ' .ajax-cart__item-remove{display:none!important}';
  document.head.appendChild(css);

  sync();
})();
